const {
  SOURCE_TCoE,
} = require('./../../../../sourceList')
const {
  ARMOR_TYPE_NATURAL,
} = require('./../../../../armorTypeList')
const {
  SPELL_SUMMON_SHADOWSPAWN,
} = require('./../../../../spellIdList')
const {
  SIZE_MEDIUM,
} = require('./../../../../sizeList')
const {
  CREATURE_TYPE_MONSTROSITY,
} = require('./../../../../creatureTypeIdList')
const {
  LANG_ITS_SUMMONER,
} = require('./../../../../languageIdList')
const {
  ALIGNMENT_NO,
} = require('./../../../../aligmentList')
const {
  SPEED_WALK,
} = require('./../../../../speedList')
const {
  CONDITION_FRIGHTENED,
} = require('./../../../../conditionList')
const {
  ATTACK_MELEE_WEAPON,
} = require('./../../../../attackTypeList')
const {
  DAMAGE_COLD,
  DAMAGE_NECROTIC,
} = require('./../../../../damageTypeList')
const {
  SENSE_DARK_VISION,
} = require('./../../../../senseList')
const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  CREATURE_DESPAIR_SHADOWSPAWN_SPIRIT,
} = require('./../../../../creatureIdList')

module.exports = {
  name: 'Дух тени отчаяния',
  nameEn: 'Despair Shadowspawn Spirit',
  id: CREATURE_DESPAIR_SHADOWSPAWN_SPIRIT,
  createdBySpellId: SPELL_SUMMON_SHADOWSPAWN,
  sizeType: SIZE_MEDIUM,
  creatureTypeIdList: CREATURE_TYPE_MONSTROSITY,
  alignmentId: ALIGNMENT_NO,
  source: {
    id: SOURCE_TCoE,
    page: 163,
  },
  armor: {
    ac: 11,
    type: ARMOR_TYPE_NATURAL,
    comment: `+ круг заклинания`,
  },
  hp: `35 + 15-кратный круг заклинания выше 3-го`,
  speed: {
    [SPEED_WALK]: 40,
  },
  params: {
    [PARAM_STR]: 13,
    [PARAM_DEX]: 16,
    [PARAM_CON]: 15,
    [PARAM_INT]: 4,
    [PARAM_WIT]: 10,
    [PARAM_CHA]: 16,
  },
  resistanceList: [
    DAMAGE_NECROTIC,
  ],
  immunityConditionList: [
    CONDITION_FRIGHTENED,
  ],
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 120,
    },
  ],
  languageList: [
    {
      id: LANG_ITS_SUMMONER,
      onlyUnderstands: true,
    },
  ],
  featureList: [
    {
      name: 'Груз печали',
      description: `Скорость всех существ (кроме заклинателя), начинающих свой ход в пределах 5 футов, уменьшается на 20 футов до начала их следующего хода.`,
    },
  ],
  actionList: [
    {
      name: 'Мультиатака',
      description: `★СУЩЕСТВО★ совершает число атак, равное половине круга заклинания.`,
    },
    {
      name: 'Леденящий ужас',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: `бонус заклинателя к атаке заклинаниями`,
        range: 5,
        hit: {
          type: DAMAGE_COLD,
          diceCount: 1,
          diceType: 12,
          diceBonus: 3,
          comment: ` + круг заклинания`,
        },
      },
    },
    {
      name: 'Жуткий вопль',
      description: `★СУЩЕСТВО★ вопит. Все существа в пределах 30 футов должны пройти испытание Мудрости или испугаться ★его★ на минуту. Испуганное существо может повторять испытание в конце каждого своего хода, завершая эффект при успехе.`,
    },
  ],
}
